(function () {
    'use strict';

    angular.module('app.designTheme', []);
})();